import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { Env } from '@/lib';

import { client } from '../../common';
import { mockUserListSchema, type MockUsers } from './types';

type Response = MockUsers;
type Variables = void;

export const useMockUsers = createQuery<Response, Variables, AxiosError>({
  queryKey: ['mock-users'],
  initialData: [],
  //placeholderData: keepPreviousData,
  fetcher: async (_, { signal }) => {
    const response = await client({
      method: 'GET',
      url: Env.API_URL + '/api/impersonation',
      signal,
    });
    return await mockUserListSchema.parseAsync(response.data);
  },
});
